<template>
  <div>
    <div class="segement-line no-border" v-if="isLoad">
      <div class="line-loading"></div>
      <div class="line-loading-tip">正在加载</div>
    </div>
    <div class="segement-line" v-else>
      <div class="line-tip">{{lineText}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    lineText: {
      type: String,
      default: '没有更多商品啦'
    },
    isLoad: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.segement-line{
  width:65%;
  margin:1.5em auto;
  line-height:1.6em;
  font-size:14px;
  text-align:center;
  border-top:1px solid #e5e5e5;
  margin-top:2em;
}
.segement-line .line-tip{
  position:relative;
  top:-.9em;
  padding:0 .55em;
  display:inline-block;
  vertical-align:middle;
  background-color:#f2f2f2;
  color:#999;
}
.line-loading{
  margin:0 5px;
  width:20px;
  height:20px;
  display:inline-block;
  vertical-align:middle;
  -webkit-animation:lineLoading 1s steps(12) infinite;
  animation:lineLoading 1s steps(12) infinite;
  background: transparent url("../../assets/icon/load_more.svg");
  background-size:100%;
}
.line-loading-tip{
  display:inline-block;
  vertical-align:middle;
  color:#999;
}
@keyframes lineLoading{
  0% {
      -webkit-transform: rotate3d(0, 0, 1, 0deg);
      transform: rotate3d(0, 0, 1, 0deg);
  }
  100% {
      -webkit-transform: rotate3d(0, 0, 1, 360deg);
      transform: rotate3d(0, 0, 1, 360deg);
  }
}
</style>
